<div class="error-message" *ngIf="razonSocialError && nombreComercialError">Por favor, escriba una razón social y nombre comercial.</div>
<div class="error-message" *ngIf="razonSocialError && !nombreComercialError">Por favor, escriba una razón social.</div>
<div class="error-message" *ngIf="!razonSocialError && nombreComercialError">El campo nombre comercial no puede estar vacío.</div>
<div class="error-message" *ngIf="(!razonSocialError && !nombreComercialError) && (telefonoError || nifError)"> Hay campos introducidos incorrectamente.</div>
<div class="ok-message fade-out" *ngIf="!razonSocialError && !nombreComercialError && !telefonoError && !nifError && clienteEditado && !errorFinal">
    El cliente se ha editado correctamente.
</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">ACTUALIZAR CLIENTE DATABEER</span>
            <button mat-icon-button matTooltip="Guardar cambios" class="gurdar-btn" (click)="guardarCliente()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text" class="font14">Formulario de clientes DataBeer</span>
    </div>
    <div class="body">
        <!--<mat-form-field class="input-container">
            <mat-label class="label-text">Razón Social</mat-label>
            <input matInput type="text" [(ngModel)]="razonSocial" placeholder="Nombre con que la entidad o sociedad mercantil está registrada legalmente">
            <button *ngIf="razonSocial" matSuffix mat-icon-button aria-label="Clear" (click)="razonSocial=''">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>-->

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container">
                <mat-label class="label-text" [ngClass]="{'error-select': razonSocialError}">Razón social</mat-label>
                <input matInput placeholder="Nombre con que la entidad o sociedad mercantil está registrada legalmente" formControlName="razonSocial" required>
                <button *ngIf="razonSocialInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('razonSocial')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="razonSocialError" class="custom1">El campo Razon social no puede estar vacío</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': nombreComercialError}">Nombre comercial</mat-label>
                <input matInput placeholder="Nombre que identifica a la empresa en el tráfico mercantil" formControlName="nombreComercial" required>
                <button *ngIf="nombreComercialInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('nombreComercial')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="nombreComercialError" class="custom1">El campo Nombre comercial no puede estar vacío</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Iniciales</mat-label>
                <input matInput placeholder="Iniciales de la empresa" formControlName="iniciales">
                <button *ngIf="inicialesInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('iniciales')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': nifError}">NIF (Número de Identificación Fiscal)</mat-label>
                <input matInput placeholder="12345678H" formControlName="nif">
                <button *ngIf="nifInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('nif')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="nifError" class="custom1">El NIF no es correcto.</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': telefonoError}">Teléfono</mat-label>
                <!--<mat-form-field matPrefix appearance="fill" style="margin: 0;">
                    +
                    <input matInput type="text" formControlName="prefijo" style="width: 60px;" value="34">
                </mat-form-field>-->
                <input matInput placeholder="600 00 00 00" formControlName="telefono" mask="000 00 00 00">
                <mat-icon matPrefix>phone</mat-icon>
                <button *ngIf="telefonoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('telefono')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="telefonoError" class="custom1">El número de teléfono introducido no es correcto.</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Persona de contacto</mat-label>
                <input matInput placeholder="Nombre y apellidos de persona de contacto" formControlName="personaContacto">
                <button *ngIf="personaContactoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('personaContacto')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </form>

        <div class="input-container2 custom2">
            <span class="label-text marginLeft1P">Estado</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Estado del cliente" [(ngModel)]="estado" [ngModelOptions]="{standalone: true}">
                    <mat-radio-button [value]="1">Activado</mat-radio-button>
                    <mat-radio-button [value]="0">Desactivado</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
</div>
<div class="dispositivos-usuarios-container">
    <div class="dispoositivos-container">
        <div class="dispositivos-header">
            <div class="dispositivos-header-content">
                <span class="font20">DISPOSITIVOS</span>
            </div>
            <span class="custom3">Lista de dispositivos DataBeer propiedad del cliente</span>
        </div>
        <div class="dispositivos-body">
            <div class="table-container">
                <div class="top-container">
                    <mat-form-field>
                        <mat-label class="negro">Filtrar</mat-label>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput (keyup)="applyFilterDatasource($event)" placeholder="Ex.nombre" #input>
                    </mat-form-field>
                </div>
                <div class="tabla">
                    <table mat-table [dataSource]="dataSource" matSort #sort="matSort">

                        <ng-container matColumnDef="dev_reference">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Referencia </th>
                            <td mat-cell *matCellDef="let element"> {{element.dev_reference}} </td>
                        </ng-container>

                        <ng-container matColumnDef="dev_label">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                            <td mat-cell *matCellDef="let element"> {{element.dev_label}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="operaciones">
                            <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                            <!--text-aling: center para alinear las celdas si hay más de un botón-->
                            <td mat-cell *matCellDef="let element">
                                <!--<button mat-button class="boton" style="color: #af8d4f;">Añadir</button>-->
                                <button mat-button class="boton amarillo" routerLink="/{{element.id}}/editar/dispositivo" >Editar</button>
                                <!--<button mat-button class="boton" style="color: #af5a4f;">Eliminar</button>-->
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <mat-paginator #paginator
                        [pageSizeOptions]="[15,30,60]" 
                        showFirstLastButtons 
                        aria-label="Elige una página"
                        class="custom4">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <div class="usuarios-container">
        <div class="usuarios-header">
            <div class="usuarios-header-content">
                <span class="font20">USUARIOS</span>
            </div>
            <span class="custom3">Lista de usuarios DataBeer propiedad del cliente</span>
        </div>
        <div class="usuarios-body">
            <div class="table-container">
                <div class="top-container">
                    <mat-form-field>
                        <mat-label class="negro">Filtrar</mat-label>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput (keyup)="applyFilterDatasource1($event)" placeholder="Ex.nombre" #input>
                    </mat-form-field>
                </div>
                <div class="tabla">
                    <table mat-table [dataSource]="dataSource1" matSort #sort1="matSort">

                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Código </th>
                            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                        </ng-container>

                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                        </ng-container>
            
                        <ng-container matColumnDef="operaciones">
                            <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                            <td mat-cell *matCellDef="let element">  
                                <button mat-button class="boton amarillo" routerLink="/usuarios/{{element.id}}/editar">Editar</button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                    </table>

                    <mat-paginator #paginator1
                        [pageSizeOptions]="[15,30,60]"  
                        showFirstLastButtons 
                        aria-label="Elige una página"
                        class="custom4">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>

